import React from 'react';
import Image from 'next/image';
import styled from 'styled-components';

import Link from '@/components/Link/Link';
import { Text } from '@/components/Text';
import { devices } from '@/styles/breakpoints';
import { TitleH2 } from '@/styles/typography';

const ToolsItem = ({ item }) => {
  const Icon = item.icon;
  return (
    <ItemWrapper>
      <Link href={item.path}>
        <ItemHeading>
          <div>
            <Icon />
          </div>
          <div className="title">{item.title}</div>
        </ItemHeading>
      </Link>
      <ItemBody>
        {item.items.map((item, idx) => (
          <ItemBodyItem key={idx}>
            <Text>{item.title}</Text>
          </ItemBodyItem>
        ))}
      </ItemBody>
    </ItemWrapper>
  );
};

export const ExploreTools = ({
  title,
  subtitle,
  description,
  items,
  image,
}) => {
  return (
    <>
      <Wrapper className="mobile">
        <Block>
          <Title>
            <p>{title}</p>
            <p>{subtitle}</p>
          </Title>
          <Description>{description}</Description>
          <Image src={image} alt={description} />
        </Block>
        <Block className="items-block">
          {items.map((item, idx) => (
            <ToolsItem item={item} key={idx} />
          ))}
        </Block>
      </Wrapper>
      <Wrapper className="desktop">
        <div style={{ width: '100%' }}>
          <Title>
            <p>{title}</p>
            <p>{subtitle}</p>
          </Title>
          <Block className="items-block">
            {items.map((item, idx) => (
              <ToolsItem item={item} key={idx} />
            ))}
          </Block>
        </div>
        <Block>
          <Image src={image} alt={description} />
        </Block>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: 24px auto;
    max-width: 625px;
    max-height: 600px;
    @media only screen and ${devices.desktop} {
      margin-top: 52px;
      margin-bottom: 0;
    }
  }

  &.desktop {
    display: none;
  }

  @media only screen and ${devices.desktop} {
    &.mobile {
      display: none;
    }
    &.desktop {
      display: flex;
      align-items: start;
      gap: 40px;
      & h2 {
        text-align: left;
        margin-bottom: 40px;
      }
    }
  }
`;

const Block = styled.div`
  width: 100%;
  &.items-block {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    @media only screen and ${devices.desktop} {
      row-gap: 40px;
    }
  }
`;

const Title = styled(TitleH2)`
  margin-bottom: 16px;
`;

const Description = styled(Text)`
  font-size: 16px;
`;

const ItemWrapper = styled.div``;

const ItemHeading = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 20px;
  line-height: 0;

  margin-bottom: 16px;
  & .title {
    font-family: var(--font-roboto);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
    color: rgba(32, 111, 237, 1);
  }
  @media only screen and ${devices.desktop} {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
`;
const ItemBody = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: start;
  row-gap: 8px;
  @media only screen and ${devices.desktop} {
    padding-left: 48px;
  }
`;

const ItemBodyItem = styled.li``;
